import { DecimalPipe } from '@angular/common';
import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toDecimal',
  standalone: true
})
@Injectable({
  providedIn: 'root'
})
export class ToDecimalPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(value: string | number, ...args: string[]): string {
    const formatPattern = Boolean(args?.length) ? args[0] : '0.0-0';

    return this.decimalPipe.transform(value, formatPattern);
  }
}
